import { render, staticRenderFns } from "./sidebar-nav.vue?vue&type=template&id=097ee07d&"
import script from "./sidebar-nav.vue?vue&type=script&lang=js&"
export * from "./sidebar-nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports